export default {
    init() {
        this. permissionBlockExpand();
        this.permissionBlockAdd();
        this.permissionBlockRemove();
    },

    permissionBlockExpand(){
        $('body').on('click','.isset-permissions-list .permission-block--heading',function (){
            let parent = $(this).parent();
            if(!parent.hasClass('active')) {
                $('.isset-permissions-list .permission-block').removeClass('active');
                $('.isset-permissions-list .permission-block--body').slideUp(100);
                parent.addClass('active');
                parent.find('.permission-block--body').slideDown(300);
            } else {
                $('.isset-permissions-list .permission-block').removeClass('active');
                $('.isset-permissions-list .permission-block--body').slideUp(100);
            }
        });

        $('body').on('click','.permission-list-all .permission-block--heading',function (){
            let parent = $(this).parent();
            if(!parent.hasClass('active')) {
                $('.permission-list-all .permission-block').removeClass('active');
                $('.permission-list-all .permission-block--body').slideUp(100);
                parent.addClass('active');
                parent.find('.permission-block--body').slideDown(300);
            } else {
                $('.permission-list-all .permission-block').removeClass('active');
                $('.permission-list-all .permission-block--body').slideUp(100);
            }
        });
    },

    permissionBlockAdd(){
        $('body').on('click','.add-permission',function (e){
            e.preventDefault();
            let element = $(this).parent().parent().parent();
            let contentHeading = element.find('.permission-block--heading').html();
            let contentInfo = element.find('.permission-block--info').html();
            element.remove();

            var controlled_route_id = $(this).attr('route_id');
            var permission_id = $(this).attr('permission_id');
            $.ajax({
                type: 'POST',
                url: '/manage/permission/add-controlled-route-ajax',
                data: {
                    "controlled_route_id": controlled_route_id,
                    "permission_id": permission_id,
                },
                success: function(response) {
                    console.log(response);
                }
            });

            let template = `
            <div class="permission-block">
                <div class="permission-block--heading">
                    ${contentHeading}
                </div>
                <div class="permission-block--body">
                    <div class="permission-block--info">
                        ${contentInfo}
                    </div>
                    <div class="permission-block--controls">
                        <a permission_id="${permission_id}"  route_id="${controlled_route_id}" class="remove-permission">
                            <i></i>
                            Remove permission
                        </a>
                    </div>
                </div>
            </div>
            `;

            $('.isset-permissions-list').append(template);

        });
    },

    permissionBlockRemove() {
        let popUp = $('.remove-role-permission-popup');
        
        $('body').on('click','.remove-permission',function (e){
            e.preventDefault();
            popUp.fadeIn(300);
            let element = $(this).parent().parent().parent();
            let contentHeading = element.find('.permission-block--heading').html();
            let contentInfo = element.find('.permission-block--info').html();


            var controlled_route_id = $(this).attr('route_id');
            var permission_id = $(this).attr('permission_id');
            $.ajax({
                type: 'POST',
                url: '/manage/permission/remove-controlled-route-ajax',
                data: {
                    "controlled_route_id": controlled_route_id,
                    "permission_id": permission_id,
                },
                success: function(response) {
                    console.log(response);
                }
            });


            // $('body').on('click','.remove-role-permission-popup .confirm',function(e) {
            //     e.preventDefault();
                element.remove();

                let template = `
                <div class="permission-block">
                    <div class="permission-block--heading">
                        ${contentHeading}
                    </div>
                    <div class="permission-block--body">
                        <div class="permission-block--info">
                            ${contentInfo}
                        </div>
                        <div class="permission-block--controls">
                            <a permission_id="${permission_id}" route_id="${controlled_route_id}" class="dark-button add-permission">
                                <i></i>
                                Add permission
                            </a>
                        </div>
                    </div>
                </div>
                `;

            $('.permission-list-all').append(template);
            popUp.fadeOut(300);
        //     });
        });

        $('.remove-role-permission-popup .close-pop').on('click', function (e) {
            e.preventDefault();
            popUp.fadeOut(300);
        });
    },

}
